module.exports = __webpack_public_path__ + "static/media/icomoon.2aff382b.svg";